import { getData } from './http';

const getAccountDetails = (id, queryParams = {}) => {
  return getData({ url: `${process.env.REACT_APP_ACCOUNT_SERVICE_BASE_URL}accounts/${id}`, queryParams });
};

export { getAccountDetails };
